module.exports = __webpack_public_path__ + "img/sculpture-installation.48cf5dad.jpg";